import { Exclude, Expose } from 'class-transformer';
import { JobPhaseCustomDateHistoryInterface } from '../interfaces/job-phase-custom-date-start-history.interface';
import { JobPhaseInterface } from '../../job-phase/interfaces/job-phase.interface';
import { UserPublicInterface } from '../../user/interfaces/user-public.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsISO8601, IsUUID } from 'class-validator';
import { UserDto } from '../../user/dto/user.dto';

@Exclude()
export class JobPhaseCustomDateStartHistoryDto
  extends CommonEntityDto
  implements JobPhaseCustomDateHistoryInterface
{
  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'uuid',
    title: 'User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiPropertyOptional({
    type: () => UserDto,
    title: 'Associated Assigning User',
    description:
      'The assigning user associated with this job phase contractor history',
  })
  @Expose()
  user?: UserPublicInterface | undefined;

  @ApiProperty({
    type: 'string',
    nullable: true,
    format: 'date-time',
    title: 'Date',
    description: 'Date',
  })
  @IsISO8601({ strict: true })
  @Expose()
  date!: Date | null;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;
  jobPhase?: JobPhaseInterface | undefined;
}
